export default {
  vsmall: '(min-width: 480px)',
  small: '(min-width: 640px)',
  smedium: '(min-width: 768px)',
  medium: '(min-width: 800px)',
  lmedium: '(min-width: 960px)',
  mlarge: '(min-width: 1120px)',
  large: '(min-width: 1240px)',
  vlarge: '(min-width: 1360px)',
  wide: '(min-width: 1500px)',
}



// WEBPACK FOOTER //
// ./scripts/settings/breakpoints.js